const uuid = require('uuid');
import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
const tolerantParse = require('tolerant-json-parser');
import styled from '@emotion/styled';
const _ = {
    find:       require('lodash/find'),
    forEach:    require('lodash/forEach'),
    includes:   require('lodash/includes'),
    map:        require('lodash/map'),
};

const ServerRequest = require('../../actions/request');
const KeyboardUtil = require('../../util/keyboard');
const AssetUtil = require('../../util/asset');
import ErrorBox from '../common/ErrorBox';
import AutoSizeTextArea from '../common/AutoSizeTextArea';
import AlwaysScrollToBottom from '../common/AlwaysScrollToBottom';
import AssetImage from '../common/AssetImage';
import SingleAssetInput from '../common/SingleAssetInput';
import ExpansionButton from '../common/ExpansionButton';
import LoadingMainContent from '../loading/LoadingMainContent';
import ConfirmModal from '../modal/ConfirmModal';

const AIUtils = require('../../util/AIUtils');

const ShortCourseEditorStore = require('../../stores/ShortCourseEditorStore');

const Strings = require('../../../../app/shared/Strings');
const Globals = require('../../../../app/globals');
import ShortCoursePlayStore from '../../stores/ShortCoursePlayStore';
const ShortCourseActions = require('../../actions/ShortCourseActions');
const ShortCourseEditorActions = require('../../actions/ShortCourseEditorActions');
const OrganizationStore = require('../../stores/OrganizationStore');
const OrganizationActions = require('../../actions/OrganizationActions');
const ShortCourseConstants = require('../../../../app/shared/ShortCourseConstants');

// const TUTORIAL_ACTIVITY_TYPES = Globals.short_course.TUTORIAL_ACTIVITY_TYPES;
// const ASSESSMENT_ACTIVITY_TYPES = Globals.short_course.ASSESSMENT_ACTIVITY_TYPES;
const REMEDIAL_ACTIVITY_TYPES = Globals.short_course.REMEDIAL_ACTIVITY_TYPES;

let SystemTextEditDiv = styled.div`
    border: solid thin grey;
    padding: 0.5rem;
    background-color: white;
    .expandable-span {
        &:hover {
            background-color: lightblue;
        }
    }
`;

let StyledUL = styled.ul`
    li {
        label {
            width: 40rem;
            margin-right: 1rem;
        }
        button {
            margin-left: 1rem;
        }
    }
`;

class EditChatbotActivityModal extends React.Component {
    constructor(props) {
        super(props);
        this.pollTaskManager = new ServerRequest.PollTaskManager();
        let orgState = OrganizationStore.getStateOrganization(props.channelId);
        let org_boilerplate = this.buildOrgBoilerplate(orgState.orgBoilerplate);
        let doc_boilerplate = this.props.doc.client_content.doc_boilerplate || {};
        let chatData = props.chatData;
        if (!chatData) {
            // adding a new virtual ai tutor
            chatData = {
                display_title: 'AI Tutoring Activity',
                description: '',
                chatbot_activity_hash: 'chatbot-' + uuid.v4(),
                activity_type: Globals.short_course.REMEDIAL_ACTIVITY_TYPES[0],
                subskill_relations: {},
                bot_options: {
                    image_url: '',
                    botName: 'Athena',
                    topic: '', //'the meaning of bias within the concept of critical thinking',
                    // formatText: null,
                    // variableEntries,
                    cb_boilerplate: {},
                },
            }
        }
        
        this.aiUtils = new AIUtils({
            doc:props.doc,
            node: props.node,
            chatData: chatData, // includes cb_boilerplate
            org_boilerplate,doc_boilerplate,
            onChangeBoilerplate: this.onChangeBoilerplate,
        });

        this.state = org_boilerplate ? this.computeState(props,org_boilerplate) : { org_boilerplate }; // don't fill in all the state until we have org_boilerplate
        this.unsubscribes = [
            OrganizationStore.listen(this.onOrgStoreChange)
        ];
    }
    
    computeState=(props,org_boilerplate)=>{
        let startingState;
        if (props.chatData) {
            // flatten bot_options back into chatData
            let { bot_options, ...otherParams} = props.chatData;
            let chatData = {...otherParams, ...bot_options };
            if (!chatData.cb_boilerplate) {
                chatData.cb_boilerplate = {};
            }
            if (typeof chatData.botName === 'undefined') {
                chatData.botName = 'Athena';
            }
            let { formatText, variableEntries, ui } = this.buildSystemTextVariablesAndUI({...chatData, org_boilerplate});

            let manualEdits = false;
            let dirty = false;
            if (chatData.system_text) {
                delete chatData.system_text; // old data
            }
            if (chatData.formatText) {
                manualEdits = (formatText !== chatData.formatText);
                dirty = manualEdits;
                if (manualEdits) {
                    ({ ui } = this.buildSystemTextVariablesAndUI({...chatData,org_boilerplate},true));
                }
            }
            if (typeof chatData.image_url === 'undefined') {
                chatData.image_url = '';
            }
            if (typeof chatData.description === 'undefined') {
                chatData.description = '';
            }
            
            startingState =  {
                ...chatData, formatText, variableEntries, ui, manualEdits, dirty, org_boilerplate,
            };
        }
        else {
            startingState = {
                display_title: 'AI Tutoring Activity',
                image_url: '',
                description: '',
                chatbot_activity_hash: 'chatbot-' + uuid.v4(),
                activity_type: Globals.short_course.REMEDIAL_ACTIVITY_TYPES[0],
                botName: 'Athena',
                topic: 'the meaning of bias within the concept of critical thinking',
                // startingUserText: 'Hello',
                subskill_relations: {},
                cb_boilerplate: {},
                dirty: false,
                manualEdits: false,
                org_boilerplate,
            }
            let { formatText, variableEntries, ui } = this.buildSystemTextVariablesAndUI(startingState);
            startingState = {...startingState, formatText, variableEntries, ui };
        }
        return startingState;
    }
    
    componentDidMount() {
        if (this.props.preview) {
            this.onToggleTest();
        }
        if (!this.state.org_boilerplate) {
            let action_getOrgBoilerplate = uuid.v4();
            this.setState({action_getOrgBoilerplate},()=>{
                OrganizationActions.getOrgBoilerplate(action_getOrgBoilerplate,this.props.channelId);
            })
        }
    }
    
    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
        delete this.unsubscribes;
        this.pollTaskManager.abandonTasks();
    }
    
    buildOrgBoilerplate=(orgArray)=>{
        if (!orgArray) {
            return;
        }
        let org_boilerplate = {};
        _.forEach(orgArray,(entry)=>{
            org_boilerplate[entry.string_id] = entry.string_value;
        });
        return org_boilerplate;
    }
    
    onOrgStoreChange=(storeState)=>{
        if (storeState.action.id == this.state.action_getOrgBoilerplate) {
            let orgState = OrganizationStore.getStateOrganization(this.props.channelId);
            let org_boilerplate = this.buildOrgBoilerplate(orgState.orgBoilerplate);
            this.aiUtils.setOrgBoilerplate(org_boilerplate);
            let changes = this.computeState(this.props,org_boilerplate); 
            this.setState({...changes, action_getOrgBoilerplate: null, org_boilerplate});
        }
    }
    
    // callback for aiUtils
    onChangeBoilerplate=(bp_source,id,value)=>{
        switch(bp_source) {
            case 'cp_boilerplate':
            {
                let cb_boilerplate = {...this.state.cb_boilerplate };
                cb_boilerplate[id] = value;
                this.setState({cb_boilerplate},()=>{
                    this.props.onSave();
                });
                break;
            }
            case 'doc_boilerplate':
            {
                let doc_boilerplate = {...this.state.doc_boilerplate };
                doc_boilerplate[id] = value;
                this.setState({doc_boilerplate},()=>{
                    ShortCourseEditorActions.setDocBoilerplate(uuid.v4(),id,value);
                });
                break;
            }
            case 'org_boilerplate':
            {
                let org_boilerplate = {...this.state.org_boilerplate};
                org_boilerplate[id] = value;
                this.setState({org_boilerplate},()=>{
                    OrganizationActions.updateOrgBoilerplateEntry(uuid.v4(),this.props.channelId,id,value);
                })
                break;
            }
            default: 
                console.log("onChangeBoilerplate",bp_source,id); // FIXME: implement this
        }
        return false;
    }
    
    getActivityTypeDisplayName=(activity_type)=>{
        if (this.props.activityTypes) {
            const entry = _.find(this.props.activityTypes,{id: activity_type});
            if (entry) {
                return entry.name;
            }
        }
        return Globals.short_course.content_block_activity_types[activity_type] ||  activity_type;
    }

    // returns { formatText, variableEntries, ui }
    buildSystemTextVariablesAndUI=(state,useExistingFormatData)=>{
        if (useExistingFormatData) {
            let { formatText, variableEntries } = state;
            let ui = this.aiUtils.makeVariableSubstitutionsForEditing({formatText, variableEntries});
            return { formatText, variableEntries, ui };
        }
        else {
            return this.aiUtils.buildSystemTextWithUIForTutor();
        }
    }
    
    parseResponse=(textResponse)=>{
        let response = textResponse; // fallback
        let progress = 0;
        let subskills = {};
        let obj;
        try {
            obj = tolerantParse.parse(textResponse); // JSON.parse(textResponse)
        }
        catch(err) {
            //console.log(err);
            //console.log("failed to parse AI response",textResponse);
            obj = null;
        }
        if (!obj) {
            // try removing line feeds
            console.log("retrying parse after removing line feeds");
            textResponse = textResponse.replace(/[\r\n]+/gm,"");
            try {
                obj = tolerantParse.parse(textResponse); // JSON.parse(textResponse)
            }
            catch(err) {
                console.log(err);
                console.log("failed to parse AI response after removing line feeds",textResponse);
            }
        }
        if (obj) {
            response = obj.response;
            progress =obj.progress;
            _.forEach(obj.subskills,(p,hash)=>{
                subskills[hash] = p;
            });
        }
        return { response, progress, subskills };
    }
    
    
//    setSystemText=(e)=>{
//        let system_text = e.target.value;
//        this.setState({system_text, dirty: false, manualEdits: true});
//    }
    
    setDefaultSystemText=()=>{
        let { formatText, variableEntries, ui } = this.buildSystemTextVariablesAndUI(this.state);
        // let system_text = this.buildSystemTextVariablesAndUI(this.state);
        if (this.state.manualEdits) {
            this.setState({
                modalConfirm: {
                    modalTitle: "Confirm Replace",
                    text: "Replace manual edits with default system text generation?",
                    confirmHandler: ()=>{
                        this.setState({modalConfirm: null,
                            formatText, variableEntries, ui, dirty: false, manualEdits: false,
                        });
                    },
                    cancelHandler: ()=>{
                        this.setState({modalConfirm: null})
                    },
                }
            });
        }
        else {
            this.setState({formatText, variableEntries, ui, dirty: false, manualEdits: false});
        }
    }
    
    toggleDiffsPanel=()=>{
        this.setState({showBoilerplateDifferences:!this.state.showBoilerplateDifferences});
    }
    
    expandDiff=(id)=>{
        let selected_boilerplate_id = this.state.selected_boilerplate_id;
        if (id === selected_boilerplate_id) {
            selected_boilerplate_id = null; // collapse existing
        }
        else {
            selected_boilerplate_id = id; // collapse existing
        }
        this.setState({selected_boilerplate_id});
    }
    
    clearBoilerplate=(bp_source,id)=>{
        this.aiUtils.onChangeBoilerplate(bp_source,id,null);
    }
    
    revertBoilerplate=(bp_source,id,isSame)=>{
        if (!isSame) {
            this.setState({
                modalConfirm: {
                    modalTitle: "Confirm Revert",
                    text: "Are you sure you wish to revert?",
                    confirmHandler: ()=>{
                        this.setState({modalConfirm: null},()=>{
                            this.clearBoilerplate(bp_source,id);
                        });
                    },
                    cancelHandler: ()=>{
                        this.setState({modalConfirm: null})
                    },
                }
            });
        }
        else {
            this.clearBoilerplate(bp_source,id);
        }
    }
    
    moveBoilerplate=(id,value,from_source,to_source)=>{
        this.aiUtils.onChangeBoilerplate(to_source,id,value);
        this.aiUtils.onChangeBoilerplate(from_source,id,null);
    }
    
    getSaveData=()=>{
        let { display_title, image_url, description, chatbot_activity_hash, activity_type, botName, topic, formatText, variableEntries, subskill_relations, cb_boilerplate } = this.state;
        let chatbotActivityData = { 
            display_title, 
            image_url, 
            description, 
            chatbot_activity_hash, 
            activity_type, 
            botName, 
            topic, 
            formatText, 
            variableEntries, 
            subskill_relations,
            cb_boilerplate,
        };
        return chatbotActivityData;
    }
    
    onSave=()=>{
        let chatbotActivityData = this.getSaveData();
        this.props.saveHandler(chatbotActivityData);
    }
    
    toggleSubskillChatTopic=(ss,e)=>{
        let subskill_relations = {...this.state.subskill_relations};
        if (e.target.checked) {
            subskill_relations[ss.hash] = {
                //name: undefined,
                //cb_score_type: undefined,
            };
        }
        else {
            delete subskill_relations[ss.hash];
        }
        this.setState({subskill_relations, dirty:true});
    }
    
    makeChatbotRequest=(chatbotState)=>{
        const usageData = {
            channelId: this.props.channelId,
            shortCourseId: this.props.shortCourseId,
        };
        
        this.setState({chatbotState,waitingFor: 'assistant', userInput:'', error:null},()=>{
            let data = {...chatbotState, modelId: ShortCoursePlayStore.AI_TUTOR_MODEL_ID, usageData };
            
            let actionId = uuid.v4();
            ServerRequest.makePollTaskRequest(`/authoring/interactive_chatbot`, 'POST', JSON.stringify(data), this.pollTaskManager, actionId)
            .then(({textResponse, messageHistory})=>{
                if (this.unsubscribes && this.state.chatbotState) {

                    let {response,progress,subskills} = this.parseResponse(textResponse);

                    let chatbotState = {...this.state.chatbotState,
                        messageHistory,
                    };
                    this.setState({chatbotState, waitingFor: 'user',progress});
                }
            })
            .catch((err)=>{
                if (this.unsubscribes) {
                    this.setState({error:err, waitingFor:null});
                }
            });
        });
    }    
    
    onToggleTest=()=>{
        if (!this.state.chatbotState) {
            let chatbotActivityData = this.getSaveData();
            let { chatbot_activity_hash, display_title, activity_type, subskill_relations, ...bot_options } = chatbotActivityData;
            let chatData = {...this.props.chatData,
                display_title,
                description: this.state.description,
                chatbot_activity_hash,
                activity_type,
                subskill_relations,
                bot_options
            };
            let aiProps = {
                doc: this.props.doc,
                node: this.props.node,
                chatData, // includes cb_boilerplate
                org_boilerplate: this.state.org_boilerplate,
                doc_boilerplate: this.props.doc.client_content.doc_boilerplate || {},
            };
            this.aiUtils.updateProps(aiProps);
            let startingUserText = 'Hello'; // this.state.startingUserText.trim() || 'Hello'; // can't be whitespace
            const {formatText, variableEntries}  = this.state;
            let systemText = this.aiUtils.makeVariableSubstitutions({formatText, variableEntries});
            let chatbotState = {
                systemText,
                textFromUser: startingUserText, 
                // messageHistory: ...
            };
            this.makeChatbotRequest(chatbotState);
        }
        else {
            this.setState({chatbotState:null, waitingFor: null});
        }
    }
    
    setUserInput=(e)=>{
        this.setState({userInput:e.target.value, error: null});
    }

    handleUserInputKeyDown=(e)=>{
        if (!this.state.chatbotState) {
            return;
        }
        let textFromUser = this.state.userInput.trim();
        if (KeyboardUtil.isEnterKey(e.keyCode)) {
            if (!textFromUser) {
                this.setState({error: new Error("Please type something")});
                return;
            }
            let chatbotState = {...this.state.chatbotState,
                textFromUser,
            };
            this.makeChatbotRequest(chatbotState);
        }
    }
    
    updateImage=(assetParams, files)=>{
        const imageUpdateActionID = uuid.v4();
        let params = {...assetParams, 
            courseHash: this.props.courseHash,
            asset_name: `course chatbot activity ${this.state.chatbot_activity_hash} image`
        };
        this.setState({ imageUpdateActionID },()=>{
            // after updating state, upload the image
            ShortCourseActions.addShortCourseVersionAsset(imageUpdateActionID, params, files, (asset_url)=>{
                // after uploading the image, set image_url
                this.setState({image_url:asset_url, imageUpdateActionID:null});
            });
        });
    }

    updateImageOnError=(errorMsg)=>{
        window.alert(errorMsg || 'Error');
    }
    

    render() {
        if (!this.state.org_boilerplate) {
            return <LoadingMainContent/>
        }

        //let system_text = this.state.system_text;
        //let numSysRows = 1 + system_text.split('\n').length;
        let { formatText:default_system_text } = this.buildSystemTextVariablesAndUI(this.state);
        let testMode = !!this.state.chatbotState;
        let diffMode = !testMode && !!this.state.showBoilerplateDifferences;
        
        let bodyContent;
        if (testMode) {
            bodyContent = (
                <div className="test-area">
                    { this.state.chatbotState.messageHistory ? 
                    _.map(this.state.chatbotState.messageHistory,(entry,i)=>{
                        if (i===0) {
                            // suppress startingUserText
                            return (
                                <span key={i}/>
                            );
                        }
                        let speaker = '';
                        let textEntry = _.find(entry.content,{type: "text"});
                        let entryText = textEntry ? textEntry.text : '';
                        switch(entry.role) {
                            case 'assistant': {
                                let {response} = this.parseResponse(entryText);
                                entryText = response;
                                speaker = this.state.botName;
                                break;
                            }
                            case 'user':
                                speaker = 'User';
                                break;
                        }
                        // let entryRows = entryText.split('\n').length;

                        return (
                            <div className="chatbot-log-row" key={i}>
                                <label>{`${speaker}:`}</label>
                                <AutoSizeTextArea value={entryText} readOnly/>
                            </div>
                        );
                    })
                    : null }
                    { (this.state.waitingFor === 'user') ? 
                    <div className="chatbot-log-row">
                        <label>{'User:'}</label>
                        <textarea value={this.state.userInput} rows="3" onChange={this.setUserInput} onKeyDown={this.handleUserInputKeyDown}/>
                        <span className="instructions">{this.state.userInput ? 'Press ENTER when finished typing.' : ''}</span>
                        <div className="progress-line">
                            <label>{'Progress:'}</label>
                            <span className="progress">{this.state.progress || 0}</span>
                        </div>
                    </div>
                    : null }
                    { (this.state.waitingFor === 'assistant') ? 
                    <>
                        { this.state.chatbotState.messageHistory ? 
                        <div className="chatbot-log-row">
                            <label>{'User:'}</label>
                            <AutoSizeTextArea value={this.state.chatbotState.textFromUser} readOnly/>
                        </div>
                        : null }
                        <div className="chatbot-log-row">
                            <label>{`${this.state.botName}:`}</label>
                            <span>{'...'}</span>
                            <span className="fa fa-refresh fa-spin"/>
                        </div>
                    </>
                    : null }
                    <AlwaysScrollToBottom/>
                </div>
            );
        }
        else if (diffMode) {
            bodyContent = (
                <div>
                    <StyledUL className="boilerplate-diffs">
                    {_.map(ShortCourseConstants.AI_BOILERPLATE,(value,id)=>{
                        let bp_data = this.aiUtils.getBoilerplateIdData(id);
                        let sourceName = this.aiUtils.getSourceDisplayName(bp_data.currentSource);
                        let currentValue = bp_data.currentValue;
                        let expanded = (this.state.selected_boilerplate_id === id);
                        let childContent;
                        if (expanded) {
                            let boilerplateChoicesContent;
                            switch(bp_data.currentSource) {
                                case 'cb_boilerplate':
                                {
                                    if (typeof bp_data.availableValues.doc_boilerplate === 'string') {
                                        let isSame = (bp_data.availableValues.org_boilerplate === currentValue);
                                        let sameText = isSame ? " (same as current)" : "";
                                        boilerplateChoicesContent = (
                                            <div className="bp-row">
                                                <label>{`Short Course Value${sameText}:`}</label>
                                                <AutoSizeTextArea readOnly value={bp_data.availableValues.doc_boilerplate}/>
                                                <button className="btn btn-primary" onClick={this.revertBoilerplate.bind(this,bp_data.currentSource,id,isSame)}>
                                                    {'Reset to short course value'}
                                                </button>
                                                { isSame ? null : 
                                                <button className="btn btn-primary" onClick={this.moveBoilerplate.bind(this,id,currentValue, bp_data.currentSource,'doc_boilerplate')}>
                                                    {'Replace short course value with content block value'}
                                                </button>
                                                }
                                            </div>
                                        );
                                    }
                                    else if (typeof bp_data.availableValues.org_boilerplate === 'string') {
                                        let isSame = (bp_data.availableValues.org_boilerplate === currentValue);
                                        let sameText = isSame ? " (same as current)" : "";
                                        boilerplateChoicesContent = (
                                            <div className="bp-row">
                                                <label>{`Org Value${sameText}:`}</label>
                                                <AutoSizeTextArea readOnly value={bp_data.availableValues.org_boilerplate}/>
                                                <button className="btn btn-primary" onClick={this.revertBoilerplate.bind(this,bp_data.currentSource,id,isSame)}>
                                                    {'Reset to organization value'}
                                                </button>
                                                { isSame ? null : 
                                                <button className="btn btn-primary" onClick={this.moveBoilerplate.bind(this,id,currentValue, bp_data.currentSource,'org_boilerplate')}>
                                                    {'Replace organization value with content block value'}
                                                </button>
                                                }
                                            </div>
                                        );
                                    }
                                    else if (typeof bp_data.availableValues.ai_boilerplate === 'string') {
                                        let isSame = (bp_data.availableValues.ai_boilerplate === currentValue);
                                        let sameText = isSame ? " (same as current)" : "";
                                        boilerplateChoicesContent = (
                                            <div className="bp-row">
                                                <label>{`Default Value${sameText}:`}</label>
                                                <AutoSizeTextArea readOnly value={bp_data.availableValues.ai_boilerplate}/>
                                                <button className="btn btn-primary" onClick={this.revertBoilerplate.bind(this,bp_data.currentSource,id,isSame)}>
                                                    {'Reset to default value'}
                                                </button>
                                                { isSame ? null : 
                                                <button className="btn btn-primary" onClick={this.moveBoilerplate.bind(this,id,currentValue, bp_data.currentSource,'doc_boilerplate')}>
                                                    {'Use this content as short course default'}
                                                </button>
                                                }
                                                { isSame ? null : 
                                                <button className="btn btn-primary" onClick={this.moveBoilerplate.bind(this,id,currentValue, bp_data.currentSource,'org_boilerplate')}>
                                                    {'Use this content as organization default'}
                                                </button>
                                                }
                                            </div>
                                        );
                                    }
                                    break;
                                } // case 'cb_boilerplate'
                                case 'doc_boilerplate':
                                {
                                    if (typeof bp_data.availableValues.org_boilerplate === 'string') {
                                        let isSame = (bp_data.availableValues.org_boilerplate === currentValue);
                                        let sameText = isSame ? " (same as current)" : "";
                                        boilerplateChoicesContent = (
                                            <div className="bp-row">
                                                <label>{`Org Value${sameText}:`}</label>
                                                <AutoSizeTextArea readOnly value={bp_data.availableValues.org_boilerplate}/>
                                                <button className="btn btn-primary" onClick={this.revertBoilerplate.bind(this,bp_data.currentSource,id,isSame)}>
                                                    {'Reset to organization value'}
                                                </button>
                                                { isSame ? null : 
                                                <button className="btn btn-primary" onClick={this.moveBoilerplate.bind(this,id,currentValue, bp_data.currentSource,'org_boilerplate')}>
                                                    {'Replace organization value with short course value'}
                                                </button>
                                                }
                                            </div>
                                        );
                                    }
                                    else if (typeof bp_data.availableValues.ai_boilerplate === 'string') {
                                        let isSame = (bp_data.availableValues.ai_boilerplate === currentValue);
                                        let sameText = isSame ? " (same as current)" : "";
                                        boilerplateChoicesContent = (
                                            <div className="bp-row">
                                                <label>{`Default Value${sameText}:`}</label>
                                                <AutoSizeTextArea readOnly value={bp_data.availableValues.ai_boilerplate}/>
                                                <button className="btn btn-primary" onClick={this.revertBoilerplate.bind(this,bp_data.currentSource,id,isSame)}>
                                                    {'Reset to default value'}
                                                </button>
                                                { isSame ? null : 
                                                <button className="btn btn-primary" onClick={this.moveBoilerplate.bind(this,id,currentValue, bp_data.currentSource,'org_boilerplate')}>
                                                    {'Use this content as organization default'}
                                                </button>
                                                }
                                            </div>
                                        );
                                    }
                                    break;
                                }
                                case 'org_boilerplate':
                                {
                                    if (typeof bp_data.availableValues.ai_boilerplate === 'string') {
                                        let isSame = (bp_data.availableValues.ai_boilerplate === currentValue);
                                        let sameText = isSame ? " (same as current)" : "";
                                        boilerplateChoicesContent = (
                                            <div className="bp-row">
                                                <label>{`Default Value${sameText}:`}</label>
                                                <AutoSizeTextArea readOnly value={bp_data.availableValues.ai_boilerplate}/>
                                                <button className="btn btn-primary" onClick={this.revertBoilerplate.bind(this,bp_data.currentSource,id,isSame)}>
                                                    {'Reset to default value'}
                                                </button>
                                            </div>
                                        );
                                    }
                                    break;
                                }
                                case 'ai_boilerplate':
                                    break;

                                default:
                                    console.log("TODO: case ",bp_data.currentSource);  // FIXME
                                    break;
                            } // switch(bp_data.currentSource)
                            
                            childContent = (
                                <div>
                                    <div className="bp-row">
                                        <label>{`Current Value (${sourceName}):`}</label>
                                        <AutoSizeTextArea readOnly value={currentValue}/>
                                    </div>
                                    {boilerplateChoicesContent}
                                </div>
                            );
                        }
                        return (
                            <li key={id}>
                                <ExpansionButton
                                    expanded={expanded}
                                    ariaText="Details"
                                    onClick={this.expandDiff.bind(this,id)}
                                    expandedIcon="fa-caret-square-o-down"
                                    collapsedIcon="fa-caret-square-o-right"
                                />
                                <label>{`${id}:`}</label>
                                { expanded ? null : <span>{sourceName}</span> }
                                {childContent}
                            </li>
                        );
                    })}
                    </StyledUL>
                    <button className="btn btn-primary" onClick={this.toggleDiffsPanel}>{'back'}</button>
                </div>
            );
        }
        else {
            bodyContent = (
                <>
                    <div className="formlike">
                        <label title={`chatbot_activity_hash: "${this.state.chatbot_activity_hash}"`}>{'Tutoring Activity Name:'}</label>
                        <input type='text' value={this.state.display_title} onChange={(e)=>{
                            this.setState({display_title:e.target.value, dirty:true});
                        }}/>
                    </div>
                    <div className="formlike activity-image-container">
                        <AssetImage
                            src={this.state.image_url || ''}
                            alt="Custom Course Image"
                            className="parent-constrained activity-image"
                            aria-hidden={true}
                        />
                        <span className="activity-description">
                            <label>{'Description:'}</label>
                            <AutoSizeTextArea value={this.state.description} onChange={(e)=>{
                                this.setState({description:e.target.value});
                            }}/>
                        </span>
                        <div className="margin-top-md margin-bottom-xl">
                            <SingleAssetInput
                                buttonOnly
                                browseText="Upload Image"
                                assetType="image"
                                assetRole="normal"
                                accept="image/*"
                                onChange={this.updateImage}
                                onError={this.updateImageOnError}
                                validateAssetType={AssetUtil.validateImageMimeType}
                                disabled={!!this.state.imageUpdateActionID}
                            />
                        </div>
                    </div>
                    
                    <div className="formlike">
                        <label>{'Gate:'}
                            <select value={this.state.activity_type || ''} onChange={ (e)=>{ this.setState({activity_type: e.target.value}) } }>
                                <option value={''} disabled>{'Select...'}</option>
                                {/*props.courseLevel ? null :
                                 _.map(TUTORIAL_ACTIVITY_TYPES,(activity_type)=>(
                                <option key={activity_type} value={activity_type}>
                                    {this.getActivityTypeDisplayName(activity_type)}
                                </option>
                                ))*/}
                                { _.map(REMEDIAL_ACTIVITY_TYPES,(activity_type)=>(
                                <option key={activity_type} value={activity_type}>
                                    {this.getActivityTypeDisplayName(activity_type)}
                                </option>
                                ))}
                            </select>
                        </label>
                    </div>
                    <div className="formlike">
                        <label>{'Name of Tutor:'}</label>
                        <input type='text' value={this.state.botName} onChange={(e)=>{
                            this.setState({botName:e.target.value, dirty:true});
                        }}/>
                    </div>
                    <div className="formlike">
                        <label>{'Topic:'}</label>
                        <textarea value={this.state.topic} onChange={(e)=>{
                            this.setState({topic:e.target.value, dirty:true});
                        }}/>
                    </div>
                    {/*<div className="formlike">
                        <label>{'Starting User Text:'}</label>
                        <textarea value={this.state.startingUserText} onChange={(e)=>{
                            this.setState({startingUserText:e.target.value});
                        }}/>
                    </div>*/}
                    
                    <div className="formlike">
                        <h2>{'Relevant Subskills:'}</h2>
                        {_.map(this.props.subskills,(ss,ss_index)=>{
                            let sr = this.state.subskill_relations[ss.hash];
                            let checked = (typeof sr !== 'undefined');
                            return (
                            <div key={ss_index}>
                                <input type='checkbox' checked={checked} onChange={this.toggleSubskillChatTopic.bind(this,ss)}/>
                                <label>{ss.display_name}</label>
                            </div>
                            )
                        })}
                    </div>
                    <div className="formlike">
                        <label>{'system text:'}</label>
                        <SystemTextEditDiv className="system-text-edit-div">
                            {this.state.ui}
                            {/*<textarea value={system_text} rows={numSysRows} onChange={this.setSystemText}/> */}
                        </SystemTextEditDiv>
                        <button className="btn btn-primary" disabled={!this.state.dirty} title={`click to set to: "${ default_system_text}"`} onClick={this.setDefaultSystemText}>{'update system text'}</button>
                        <button className="btn btn-primary" title={`click to view boilerplate differences`} onClick={this.toggleDiffsPanel}>{'boilerplate diffs'}</button>
                    </div>
                </> 
            );
        }
        
        if (this.state.modalConfirm) {
            let { modalTitle, text, confirmHandler, cancelHandler } = this.state.modalConfirm;
            return (
                <ConfirmModal key="confirmModal"
                    theme="new"
                    show={true}
                    modalTitle={modalTitle}
                    text={text}
                    buttonText={"confirm"}
                    confirmHandler={confirmHandler}
                    cancelButtonText={"cancel"}
                    cancelHandler={cancelHandler}
                    closeHandler={cancelHandler}
                    confirmButtonBsStyle="info"
                    cancelButtonBsStyle="info"
                    enforceFocus
                    restoreFocus
                    backdrop
                />
            );
        }
        
        return (
            <Modal dialogClassName="short-course-chatbot-activity-modal"
                key="mainModal"
                show={true}
                keyboard
                autoFocus
                enforceFocus={false}
                restoreFocus={false}
                backdrop={false}
                animation={false}
                onHide={this.props.closeHandler}
                aria-labelledby="chatbot-activity-editor"
            >
                <Modal.Header closeButton closeLabel={Strings['en'].common.CLOSE} onHide={this.props.closeHandler}>
                    <Modal.Title id="chatbot-activity-editor">{this.props.preview ? this.state.display_title : this.props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="formlike chatbot-activity-editor-body">
                        { bodyContent }
                        <ErrorBox error={this.state.error} />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    { this.props.preview ? 
                    <button className="btn btn-primary" onClick={this.props.closeHandler}>{Strings['en'].common.CLOSE}</button>
                    :
                    <>
                        <button className="btn btn-primary" onClick={this.onSave}>{this.props.chatData ? Strings['en'].common.UPDATE : Strings['en'].common.ADD}</button>
                        <button className="btn btn-primary" onClick={this.onToggleTest}>{testMode ? 'Return to editing' : 'Test AI Tutor'}</button>
                        <button className="btn btn-primary" onClick={this.props.closeHandler}>{Strings['en'].common.CANCEL}</button>
                    </>
                    }
                </Modal.Footer>
            </Modal>
        );
    } // render
}; // EditChatbotActivityModal

EditChatbotActivityModal.propTypes = {
    doc: PropTypes.object.isRequired,
    node: PropTypes.object.isRequired,
    courseHash: PropTypes.string.isRequired,
    saveHandler: PropTypes.func.isRequired,
    closeHandler: PropTypes.func.isRequired,
    subskills: PropTypes.array,
    title: PropTypes.string,
    chatData: PropTypes.object, // this is the contentBlock (cb)
    activityTypes: PropTypes.array.isRequired,
    preview: PropTypes.bool,
};

EditChatbotActivityModal.defaultProps = {
    title: "Chatbot Activity Editor",
};

export default EditChatbotActivityModal;